import { getTheme } from "../../../graphic/theme";

import { CIRCLE_NUMBER_TYPE } from "../../../graphic/constants";

import { BaseRender } from "./base-render";

import { defaultCircleBackgroundRenderContribution, defaultCircleRenderContribution, defaultCircleTextureRenderContribution } from "./contributions";

export class DefaultCanvasCircleRender extends BaseRender {
    constructor(graphicRenderContributions) {
        super(), this.graphicRenderContributions = graphicRenderContributions, this.numberType = CIRCLE_NUMBER_TYPE, 
        this.builtinContributions = [ defaultCircleRenderContribution, defaultCircleBackgroundRenderContribution, defaultCircleTextureRenderContribution ], 
        this.init(graphicRenderContributions);
    }
    drawShape(circle, context, x, y, drawContext, params, fillCb, strokeCb) {
        const circleAttribute = getTheme(circle, null == params ? void 0 : params.theme).circle, {radius: radius = circleAttribute.radius, startAngle: startAngle = circleAttribute.startAngle, endAngle: endAngle = circleAttribute.endAngle, x: originX = circleAttribute.x, y: originY = circleAttribute.y, fillStrokeOrder: fillStrokeOrder = circleAttribute.fillStrokeOrder} = circle.attribute, data = this.valid(circle, circleAttribute, fillCb, strokeCb);
        if (!data) return;
        const {fVisible: fVisible, sVisible: sVisible, doFill: doFill, doStroke: doStroke} = data;
        context.beginPath(), context.arc(x, y, radius, startAngle, endAngle), context.closePath(), 
        context.setShadowBlendStyle && context.setShadowBlendStyle(circle, circle.attribute, circleAttribute), 
        this.beforeRenderStep(circle, context, x, y, doFill, doStroke, fVisible, sVisible, circleAttribute, drawContext, fillCb, strokeCb);
        const _runFill = () => {
            doFill && (fillCb ? fillCb(context, circle.attribute, circleAttribute) : fVisible && (context.setCommonStyle(circle, circle.attribute, originX - x, originY - y, circleAttribute), 
            context.fill()));
        }, _runStroke = () => {
            doStroke && (strokeCb ? strokeCb(context, circle.attribute, circleAttribute) : sVisible && (context.setStrokeStyle(circle, circle.attribute, originX - x, originY - y, circleAttribute), 
            context.stroke()));
        };
        fillStrokeOrder ? (_runStroke(), _runFill()) : (_runFill(), _runStroke()), this.afterRenderStep(circle, context, x, y, doFill, doStroke, fVisible, sVisible, circleAttribute, drawContext, fillCb, strokeCb);
    }
    draw(circle, renderService, drawContext, params) {
        const circleAttribute = getTheme(circle, null == params ? void 0 : params.theme).circle;
        this._draw(circle, circleAttribute, !1, drawContext, params);
    }
}
//# sourceMappingURL=circle-render.js.map
